import { render, staticRenderFns } from "./answersPeopleNewadded.vue?vue&type=template&id=6a8d994a&scoped=true&"
import script from "./answersPeopleNewadded.vue?vue&type=script&lang=js&"
export * from "./answersPeopleNewadded.vue?vue&type=script&lang=js&"
import style0 from "./answersPeopleNewadded.vue?vue&type=style&index=0&id=6a8d994a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8d994a",
  null
  
)

export default component.exports